export default __webpack_public_path__ + "static/media/Beer.cd06ed12.jpg";